import { render, staticRenderFns } from "./StudentEditProjectGradeSlidebar.vue?vue&type=template&id=baad7760"
import script from "./StudentEditProjectGradeSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentEditProjectGradeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports